import './AIAssistantBanner.scss';

import Button from 'components/Buttons/Button';
import { browserRoutes } from 'constants/routes';
import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as WgptIcon } from 'static/icons/robot-face-smile-default.svg';
import { ReactComponent as ExternalLink } from 'static/icons/square_arrow_up_left_white.svg';

const AIAssistantBanner = () => {
    return (
        <div className="ai-assistant-banner">
            <img
                className="banner-image-background"
                src="https://d2csxpduxe849s.cloudfront.net/media/1A5E29DF-FF86-4C9C-A79A5FDFC62B473A/849CFE92-9333-4F32-BE232CAFE7583B10/webimage-A18D52E1-48B5-45CF-8C5627B57C49DCCD.png"
                alt=""
            />
            <div className="ai-assistant-banner__container">
                <div className="ai-assistant-banner__container__icon">
                    <WgptIcon />
                </div>
                <div className="ai-assistant-banner__container__title">
                    Need Quick HR Support? Meet the MyHR AI Assistant!
                </div>
                <div className="ai-assistant-banner__container__description">
                    Get instant answers to generic HR-related questions, all of which can also be
                    found in the
                    <Link
                        className="ai-assistant-banner__container__link"
                        to={`/${browserRoutes.collection}`}
                    >
                        {" "}
                        Knowledge Collection{" "}
                    </Link>
                    - with our AI-powered assistance (WärtsiläGPT).
                </div>
                <Button
                    to="https://wgpt-chat.app.wartsila.com/myhr-chat"
                    variant="primary"
                    size="small"
                >
                    <span className="ai-assistant-banner__container__button">
                        <span>Chat with MyHR AI Assistant</span>
                        <span className="ai-assistant-banner__container__externallink">
                            <ExternalLink />
                        </span>
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default AIAssistantBanner;
